import { FuelIcon, FuelTypography } from '@frete.com/fuel-react';
import { FC } from 'react';

import { FeatureItem, FeaturesList } from './styled';

export const Faster: FC = () => (
  <FeaturesList>
    <FeatureItem>
      <FuelIcon name="id-card" iconStyle="filled" size="medium" />
      <FuelTypography size="body-lg" weight="medium" color="neutral-default">
        <FuelTypography displayInline weight="bold">
          Formulário pré-preenchido:
        </FuelTypography>{' '}
        dados cadastrados por mais de 800mil motorista Fretebras e verificados em bases seguras para retornar o
        formulário pré-preenchidos em segundos.
      </FuelTypography>
    </FeatureItem>
    <FeatureItem>
      <FuelIcon name="clock" iconStyle="filled" size="medium" />
      <FuelTypography size="body-lg" weight="medium" color="neutral-default">
        <FuelTypography displayInline weight="bold">
          Retorno:
        </FuelTypography>{' '}
        30 minutos/cadastro e imediato para consultas.
      </FuelTypography>
    </FeatureItem>
  </FeaturesList>
);
